module.exports = "/_next/static/images/0a8fbc0d7f5303324fd526105f9294b0-LogoLiverpool.jpg";